import React from 'react';
import { Box, Grid } from '@mui/material';
import SearchFilter from '../../../components/filters/SearchFilter';
import DateRangeFilter from '../../../components/filters/DateRangeFilters';
import PurchaseInvoiceRegisterFilters from './PurchaseInvoiceRegisterFilters';

const PurchaseInvoiceRegisterListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  dateRange,
  onDateRangeChange,
  documentModeFilter,
  onDocumentModeFilterChange,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');

  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <PurchaseInvoiceRegisterFilters
            documentModeFilter={documentModeFilter}
            onDocumentModeFilterChange={onDocumentModeFilterChange}
          />
        </Grid>
        <Grid item>
          <DateRangeFilter value={dateRange} onChange={onDateRangeChange} />
        </Grid>
      </Grid>
      <Grid item>
        <Box display="flex" gap={1} justifyContent="flex-end">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default PurchaseInvoiceRegisterListFilters;
